import { MonoBehavior } from 'game/core/monoBehavior';
import { Store } from 'game/store/gameStore';
import { updateUIState, uiStore } from 'ui';
import { cloneDeep } from 'lodash';
import { EventName } from 'game/events/eventsName';
import { ActionType } from 'game/quests/types';
import { GameEvent } from 'game/events/gameEvent';

export default class TimeCounter extends MonoBehavior {

    private value: string = '00:00';

    update(): void {
        const newValue = Store.getTimeFormat(Store.time);

        if (this.value != newValue) {
            this.value = newValue;
            
            const currentState = uiStore.getState().gameUI;
            uiStore.dispatch(updateUIState({
                gameStats: {
                    ...cloneDeep(currentState.gameStats),
                    time: newValue
                }
            }));

            Store.increaseContextValue('time', 1).then((context) => {
                GameEvent.emit(EventName.MISSION_ACTION, { type: ActionType.TIMER, payload: {
                    gameName: Store.name,
                    difficulty: Store.difficulty,
                    moves: Store.movesCount,
                    time: Store.time,
                    timeMinutes: context.time / 60,
                    magicWandUses: Store.magicWandUsed,
                }, currentProgress: context.time / 60 });
            });
        }
    }
}
